module.exports = __webpack_public_path__ + "static/media/dashboard.bfd591a5.png";